/** @format */
import { TaxonomyTerm } from '@toucan/client/global/taxonomy';

import { popularBrands } from '@toucan/client/core/brand';

export const getFilteredBrandsByShortList = (
    brands?: TaxonomyTerm,
    shortList = popularBrands
) => {
    if (!brands) {
        return brands;
    }

    return {
        ...brands,
        children: shortList
            .map((brand) => {
                return brands.children.find(({ id }) => id === brand.id);
            })
            .filter(Boolean) as TaxonomyTerm[],
    };
};
